export default "__VITE_ASSET__CAyEEfwg__"